<svg width="16" height="9" viewBox="0 0 16 9" fill="none" stroke="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M15 1L8 8L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
